import React from 'react';
import { MessageCircle, FileText, Camera, Sparkles } from 'lucide-react';
export function Process() {
  const steps = [{
    icon: MessageCircle,
    title: 'Kennenlerngespräch',
    description: 'Wir besprechen Ihre Ziele, Wünsche und wie wir Ihre Marke visuell am besten präsentieren.'
  }, {
    icon: FileText,
    title: 'Konzept & Shooting-Plan',
    description: 'Ich erstelle ein maßgeschneidertes Konzept inklusive Location-Scouting und Outfit-Beratung.'
  }, {
    icon: Camera,
    title: 'Shooting-Tag',
    description: 'In entspannter Atmosphäre setzen wir das Konzept um. Ich leite Sie an, damit Sie sich wohlfühlen.'
  }, {
    icon: Sparkles,
    title: 'Bildauswahl & Retusche',
    description: 'Sie wählen Ihre Favoriten aus, die ich anschließend professionell und natürlich retuschiere.'
  }];
  return <section className="py-20 bg-gray-50" data-id="element-104">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-105">
        <div className="text-center mb-16" data-id="element-106">
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4" data-id="element-107">
            So arbeiten wir zusammen
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto" data-id="element-108">
            Ein strukturierter Prozess für entspannte Shootings und perfekte
            Ergebnisse.
          </p>
        </div>

        <div className="relative" data-id="element-109">
          {/* Connecting Line (Desktop only) */}
          <div className="hidden lg:block absolute top-12 left-0 w-full h-0.5 bg-gray-200 -z-10" data-id="element-110" />

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10" data-id="element-111">
            {steps.map((step, index) => <div key={index} className="flex flex-col items-center text-center bg-gray-50 lg:bg-transparent p-4 rounded-lg" data-id="element-112">
                <div className="w-24 h-24 rounded-full bg-white border-4 border-[#D4A574] flex items-center justify-center mb-6 shadow-sm relative z-10" data-id="element-113">
                  <step.icon className="h-10 w-10 text-[#D4A574]" strokeWidth={1.5} data-id="element-114" />
                  <div className="absolute -top-2 -right-2 w-8 h-8 rounded-full bg-gray-900 text-white flex items-center justify-center font-bold text-sm" data-id="element-115">
                    {index + 1}
                  </div>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-116">
                  {step.title}
                </h3>
                <p className="text-gray-600 text-sm leading-relaxed" data-id="element-117">
                  {step.description}
                </p>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}